
















































































































































// Incluimos los mensajes de este módulo
import { S3 } from "@/common/s3";
import ResponseData from "@/models/store/ProveedoresTypesData";
import dataService from "@/services/proveedoresAPI";
import Snackbar from "@/components/ModalFormNewResgister/snackbar.vue";
import GlobalMixin from "@/mixins/global";
import EditRegisterContract from "@/components/ModalRegisterContract/EditRegisterContract.vue";
import DeleteDialogContract from "@/components/ModalRegisterContract/DeleteDialogContract.vue";
import AutorizationTerms from "@/components/Autorization/AutorizationTerms.vue";

export default GlobalMixin.extend({
  components: {
    EditRegisterContract,
    DeleteDialogContract,
    Snackbar,
    AutorizationTerms,
  },
  props: [
    "headers",
    "items",
    "sortBy",
    "loading",
    "proveedor",
    "documentoSeccion",
    "forceUpdate",
  ],
  data() {
    return {
      dataTableDocument: [],

      title: "",
      moduleName: "DATATABLE_REGISTER_CONTRACT",
      dialog: false,
      dialogDelete: false,
      dialogRefuse: false,
      // snackbar
      snackbar: false,
      text: "",
      timeout: 2000,
      color: "",

      renderComponent: true,

      // Registros
      editedIndex: -1,
      editedItem: {},
      enabledEdit: 0,
      keyFileTempRefuse: "",

      //Data table
      headerProps: {
        sortByText: "Ordenar por",
      },
      footerProps: {
        itemsPerPageText: "Registros por página",
        itemsPerPageAllText: "Todos",
        pageText: "{0}-{1} de {2}",
        sortByText: "Ordenar por",
      },
      loadingText: "Cargando... Por favor espere",
      noDataText: "Sin datos",
    };
  },
  methods: {
    // Es usado para actualizar los items de
    // las tablas de los documentos
    forceRerender() {
      // Remove my-component from the DOM
      this.renderComponent = false;
      this.$nextTick(() => {
        // Add the component back in
        this.renderComponent = true;
      });
    },
    closeSnackbar() {
      this.snackbar = false;
    },

    closeDialog() {
      this.dialog = false;
      this.resetIndexItem();
    },

    openDialog() {
      this.enabledEdit = 0;
      this.dialog = true;
    },
    deleteItem(item: object) {
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },
    deleteItemConfirm() {
      this.items.splice(this.editedIndex, 1);
      if (this.forceUpdate) {
        this.forceRerender();
      }
      this.closeDelete();
    },
    closeDelete() {
      this.dialogDelete = false;
      this.resetIndexItem();
    },
    resetIndexItem() {
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, {});
        this.editedIndex = -1;
      });
    },

    saveItem() {
      if (this.editedIndex > -1) {
        Object.assign(this.items[this.editedIndex], this.editedItem);
      } else {
        this.items.push(this.editedItem);
      }
      this.closeDialog();
    },

    editItem(item: object) {
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.enabledEdit = 0;
      this.dialog = true;
    },
    updateEnabledEdit() {
      this.enabledEdit = 1;
    },
    async getFile(fileName: string) {
      const result: any = await S3.get(fileName);
      if (Object.keys(result).length) {
        let blob = new Blob([result.Body], { type: result.ContentType });
        let link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
      } else {
        this.text = "No se encontro el archivo solicitado";
        this.snackbar = true;
        this.color = "red darken-2";
      }
    },
    refuseItem(item: any) {
      this.keyFileTempRefuse = item.docBucketKeyFile;
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogRefuse = true;
    },
    RefuseItemConfirm() {
      this.closeRefuse();
    },
    closeRefuse() {
      this.dialogRefuse = false;
      this.resetIndexItem();
    },
    saveItemRefuse() {
      if (this.editedIndex > -1) {
        Object.assign(this.items[this.editedIndex], this.editedItem);
      }
      this.closeRefuse();
    },

    // Activar notificacion
    notificacion(mensaje: string, color: string) {
      this.text = mensaje;
      this.color = color;
      this.snackbar = true;
      window.setTimeout(() => {
        this.snackbar = false;
      }, this.timeout);
    },

    autorizar(item: any) {
      this.editedIndex = this.items.indexOf(item);
      dataService
        .approveDocuments(item.docID)
        .then((Response: ResponseData) => {
          item.docEstatusID = 2;
          Object.assign(this.items[this.editedIndex], item);
          this.text = "Registro autorizó";
          this.snackbar = true;
          this.color = "success";
          this.resetIndexItem();
        })
        .catch((e: Error) => {
          this.text = "No se autorizó el registro, intente de nuevo más tarde ";
          this.snackbar = true;
          this.color = "red darken-2";
          this.resetIndexItem();
        });
    },
  },
});
